module.exports = __webpack_public_path__ + "img/User_management.9b2f21d6.svg";